import { useQuery } from "@apollo/client";
import {
	Box,
	Button,
	Table,
	TableContainer,
	Tbody,
	Td,
	Text,
	Th,
	Thead,
	Tr,
	useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NoItemsAvailableCard from "../../Components/Cards/NoItemsAvailableCard";
import { GET_INTERESTED_PROPERTIES } from "../../Components/Graphql/Queries";

const thStyles = {
	fontSize: "14px",
	fontWeight: "bold",
	textTransform: "none",
	color: "black",
	padding: "8px",
};

const tdStyles = {
	fontSize: "14px",
	fontWeight: "400",
	color: "#212529",
	padding: "8px",
};

const InterestedProperties = () => {
	let navigate = useNavigate();
	const toast = useToast();
	const { error, data, loading } = useQuery(GET_INTERESTED_PROPERTIES, {
		fetchPolicy: "network-only",
	});
	const [interestedProperties, setInterestedProperties] = useState([]);

	useEffect(() => {
		console.log("error:", error);
		console.log("loading:", loading);
		console.log("data:", data);

		if (data != undefined) {
			console.log("data from interested properties: ", data);
			setInterestedProperties(data?.getInterestedProperties?.properties);
		}
		if (error != undefined) {
			toast({
				title: "error",
				description: error.message,
				status: "error",
				duration: 4000,
				isClosable: true,
			});
		}
	}, [data, loading, error]);

	return (
		<Box w="100%">
			<Text fontSize="20px" color="#333" marginLeft="30px" marginBottom="10px">
				Expressed Interests
			</Text>
			<Box
				color="#315B84"
				background="#FFFFFF"
				padding="20px 25px 15px 25px"
				w="100%"
				borderRadius="15px"
			>
				{interestedProperties.length > 0 ? (
					<TableContainer>
						<Table>
							<Thead>
								<Tr>
									<Th {...thStyles}>Name</Th>
									<Th {...thStyles}>Ticker ID</Th>
									<Th {...thStyles}>Status</Th>
									<Th {...thStyles}>Units</Th>
									<Th {...thStyles}>Value</Th>
									<Th {...thStyles}>.</Th>
								</Tr>
							</Thead>
							<Tbody>
								{interestedProperties.map((property, index) => (
									<Tr key={index}>
										<Td {...tdStyles}>{property.name}</Td>
										<Td {...tdStyles}>{property.tickerSymbol}</Td>
										<Td {...tdStyles} textTransform={"capitalize"}>
											{property.propertyStatus}
										</Td>
										<Td {...tdStyles}>{property.performanceMetrics.units}</Td>
										<Td {...tdStyles}>
											${property?.performaceMetrics?.pricePerToken}
										</Td>
										<Td {...tdStyles}>
											<Button
												onClick={() =>
													navigate(`/property/${property.id}`)
												}
												fontWeight="300"
												backgroundColor="#0d6efd"
												color="white"
												_hover={{
													backgroundColor: "#0a58ca",
												}}
												padding="4px 8px"
												fontSize="14px"
											>
												View
											</Button>
										</Td>
									</Tr>
								))}
							</Tbody>
						</Table>
					</TableContainer>
				) : (
					<NoItemsAvailableCard />
				)}
			</Box>
		</Box>
	);
};

export default InterestedProperties;
